import { StaticBaseDao } from '@/dao';
import {
    DeviceTransactionStatistics,
    StationDeviceStatusWithCount,
    DeviceEvent,
    StationDeviceStatus,
    StringArray,
    DeviceStatus,
} from '@/objects/generated';
import { formatDateIso } from '@/utilities/dateutils';
import { useUserStore } from '@/stores';

export class DeviceDao extends StaticBaseDao {
    public static async GetTransactionsForDevice(
        DeviceID: string | null,
        lastSeconds?: number,
    ): Promise<DeviceTransactionStatistics | null> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return null;
        }
        return this.BaseFetch(
            DeviceTransactionStatistics,
            `Device/GetTransactionsForDevice` +
                '?' +
                (DeviceID == undefined ? '' : `DeviceID=${DeviceID}`) +
                '&' +
                (lastSeconds == undefined ? '' : `lastSeconds=${lastSeconds}`),
            'GET',
        );
    }
    public static async GetStationDeviceStatusesWithMessageCount(): Promise<StationDeviceStatusWithCount[]> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return [];
        }
        return this.BaseFetchArray(StationDeviceStatusWithCount, `Device/GetStationDeviceStatusesWithMessageCount`, 'GET');
    }
    public static async GetDeviceEvents(from?: Date | null, to?: Date | null): Promise<DeviceEvent[]> {
        return this.BaseFetchArray(
            DeviceEvent,
            `Device/DeviceEvents` +
                '?' +
                (from == undefined ? '' : `from=${from ? formatDateIso(from) : null}`) +
                '&' +
                (to == undefined ? '' : `to=${to ? formatDateIso(to) : null}`),
            'GET',
        );
    }
    public static async GetStationDeviceStatusForEvent(EventID: number): Promise<StationDeviceStatus[]> {
        return this.BaseFetchArray(
            StationDeviceStatus,
            `Device/DeviceStatus/Event` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
    public static async GetStationDeviceStatuses(devices: StringArray): Promise<StationDeviceStatus[]> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return [];
        }
        return this.BaseFetchArray(StationDeviceStatus, `Device/StationDeviceStatus`, 'POST', devices);
    }
    public static async GetDeviceStatusForDevices(EventID: number, deviceIds: StringArray): Promise<DeviceStatus[]> {
        return this.BaseFetchArray(
            DeviceStatus,
            `Device/DeviceStatus` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            deviceIds,
        );
    }
    public static async GetDeviceEvent(eventId: number): Promise<DeviceEvent | null> {
        return this.BaseFetch(DeviceEvent, `Device/DeviceEvent` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`), 'GET');
    }
}
